import { render, staticRenderFns } from "./review-card.vue?vue&type=template&id=6a4300f8&scoped=true"
import script from "./review-card.vue?vue&type=script&lang=js"
export * from "./review-card.vue?vue&type=script&lang=js"
import style0 from "./review-card.vue?vue&type=style&index=0&id=6a4300f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4300f8",
  null
  
)

export default component.exports